
const actions = {
    SET_LANG: 'SET_LANG',
    SET_REGION_LOGO: 'SET_REGION_LOGO',
    SET_APIKEY: 'SET_APIKEY',
    SET_BUILDING_ID: 'SET_BUILDING_ID',
    SET_BUILDING_CODE: 'SET_BUILDING_CODE',
    SET_FLOORTABLE: 'SET_FLOORTABLE',
    SET_FLOORLIST: 'SET_FLOORLIST',
    SET_SEARCHTYPE: 'SET_SEARCHTYPE',
    SET_KIOSK_POI_ID: 'SET_KIOSK_POI_ID',
    SET_SELF_KIOSK_ID: 'SET_SELF_KIOSK_ID',
    SET_START_POINT: 'SET_START_POINT',
};

export default actions;
